<template>
    <TipBox info :title="$t('tips.notifications.title')">
        <h4 v-html="$t('tips.notifications.description')"></h4>
        <ul>
            <li v-html="$t('tips.notifications.li_1')"></li>
            <li v-html="$t('tips.notifications.li_2')"></li>
            <li v-html="$t('tips.notifications.li_3')"></li>
            <li v-html="$t('tips.notifications.li_4')"></li>
            <li v-html="$t('tips.notifications.li_5')"></li>
        </ul>
        <h4 v-html="$t('tips.notifications.sms.title')"></h4>
        <p v-html="$t('tips.notifications.sms.description')"></p>
        <h4 v-html="$t('tips.notifications.email.title')"></h4>
        <p v-html="$t('tips.notifications.email.description')"></p>
    </TipBox>
</template>

<script>
    export default {
      name: "TipsNotification"
    }
</script>